<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <h4 class="text-center font-bold text-root-4 md:text-lg">
      Reason for Transfer
    </h4>
    <p class="text-xs text-root-4 font-normal text-center">Select a reason</p>
    <div class="radios flex flex-col gap-y-4 mt-6">
      <el-radio
        v-for="reason in reasons"
        :key="reason.id"
        v-model="transferReason"
        :label="reason.name"
        class="text-root-4"
        >{{ reason.name }}</el-radio
      >
    </div>
    <transition name="slide-fade">
      <textarea
        v-if="transferReason === 'Custom Reason'"
        v-model="customReason"
        class="outline-none w-full border rounded-xl mt-5 px-4 py-2 h-24 text-sm"
        placeholder="Type a reason here"
      >
      </textarea>
    </transition>

    <div class="continue-button flex items-center mt-8">
      <o-button
        class="g-root-5 text-white text-center w-full rounded-3xl transition-all duration-300 hover:opacity-70 text-sm md:text-base"
        :disabled="!reasonHandler"
        :class="{
          'bg-primary': reasonHandler,
          'cursor-not-allowed': !reasonHandler
        }"
        @click="nextHandler"
      >
        {{ 'Next' }}</o-button
      >
    </div>
  </el-dialog>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'TransferReasonDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      transferReason: '',
      customReason: '',

      reasons: [
        {
          name: 'Salary Payment',
          id: 1
        },
        {
          name: 'Flight Booking',
          id: 2
        },
        {
          name: 'Paying Partners',
          id: 3
        },
        {
          name: 'Custom Reason',
          id: 4
        }
      ]
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    reasonHandler () {
      return (
        (this.transferReason && this.transferReason !== 'Custom Reason') ||
        this.customReason.length > 4
      )
    }
  },
  methods: {
    nextHandler () {
      // for custom reason
      if (this.transferReason !== 'Custom Reason') {
        this.$emit('next', this.transferReason)
      } else {
        if (this.customReason.length > 4) {
          this.$emit('next', this.customReason)
        }
      }
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
button {
  border-radius: 200px;
}

.slide-fade-enter-active {
  animation: slide-fade 0.3s ease forwards;
}
.slide-fade-leave-active {
  animation: slide-fade 0.3s ease forwards alternate-reverse;
}
/* animation for  */
@keyframes slide-fade {
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }
  70% {
    opacity: 0.7;
    transform: translateY(10%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}

@media screen and (max-width: 768px) {
  >>> .el-radio__label {
    font-size: 12px;
  }
}
</style>
